// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen` from
// x-flags.doRenderReactQueryQueryHook on POST /contest/list.

import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import type {
  typeContestListBody,
  typeContestListOutput200,
} from "../../sdk/contest/postContestList";
import useCallSdk from "../../sdk-helpers/useCallSdk";

export function buildContestListQueryKey(
  payload: typeContestListBody,
): string[] {
  const queryKeySegments: string[] = [];
  queryKeySegments.push(`poolId:${JSON.stringify(payload.poolId)}`);
  if (typeof payload.seasonId !== "undefined") {
    queryKeySegments.push(`seasonId:${JSON.stringify(payload.seasonId)}`);
  }
  return ["post:contest:contestList", "svc:contest-api", ...queryKeySegments];
}

type QueryOptions = Partial<
  UseQueryOptions<
    typeContestListOutput200,
    unknown,
    typeContestListOutput200,
    string[]
  >
> & {
  // Isolates two callers that query the same data for independent UI state
  // (e.g. a dropdown search vs a table both listing the same resource).
  queryKeyIdentifier?: string;
};

export default function useContestList(
  payload: typeContestListBody,
  options?: QueryOptions,
) {
  // No staleTime default here on purpose. Freshness is the consuming app's
  // decision and belongs in its QueryClient, in one place: a default set on the
  // hook would silently beat it for every screen. Pass one per call to override.
  const resolvedOptions = options ?? {};

  let queryKey = buildContestListQueryKey(payload);
  if (resolvedOptions.queryKeyIdentifier) {
    queryKey = [...queryKey, resolvedOptions.queryKeyIdentifier];
  }

  const { callSdk } = useCallSdk();
  return useQuery({
    queryKey,
    queryFn: () => callSdk().postContestList(payload),
    ...resolvedOptions,
  });
}
